import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.0625 52.5V48.75H49.25V11.25H31.0625V7.5H49.25C50.25 7.5 51.125 7.875 51.875 8.625C52.625 9.375 53 10.25 53 11.25V48.75C53 49.75 52.625 50.625 51.875 51.375C51.125 52.125 50.25 52.5 49.25 52.5H31.0625ZM26.1875 40.9375L23.5 38.25L29.875 31.875H8V28.125H29.75L23.375 21.75L26.0625 19.0625L37.0625 30.0625L26.1875 40.9375Z",
		fill: "#E9F1F3"
	})
});
export default SvgLogin;
